import React from 'react';
import {withStyles} from "@material-ui/core";
import LayoutLegacy from '../components/Layout/LayoutLegacy';
import i18n from "../i18n";
import Toolbar from "../components/Toolbar/Toolbar";

const Legacy = ({classes, session, title}) => {
    return (
        <LayoutLegacy></LayoutLegacy>
    );
};


const styles = theme => ({
});

export default withStyles(styles)(Legacy);
